let focusedElementBeforeModal;
let overlay = document.getElementById('intervening-overlay');
let popup = document.getElementById('intervening-popup');
let continueBtn = document.getElementById('link-continue-btn');
let closeBtn = document.getElementById('close-intervening');

function runInterveningPopup(url) {

    focusedElementBeforeModal = document.activeElement;

    //keyboard trap
    popup.addEventListener('keydown', trapTapKey);
    let focusableElementsString = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
    let focusableElements = Array.from(popup.querySelectorAll(focusableElementsString));

    let firstTabStop = focusableElements[0];
    let lastTabStop = focusableElements[focusableElements.length - 1];

    //open modal
    popup.style.display = 'block';
    popup.setAttribute('aria-hidden', 'false');
    overlay.style.display = 'block';
    continueBtn.setAttribute('href', url);

    //Focus first child
    firstTabStop.focus();

    //keyboard trap function
    function trapTapKey(e) {
        if (e.keyCode === 9) {
            // SHIFT + TAB
            if (e.shiftKey) {
                if (document.activeElement === firstTabStop) {
                    e.preventDefault();
                    lastTabStop.focus();
                }
                // TAB
            } else {
                if (document.activeElement === lastTabStop) {
                    e.preventDefault();
                    firstTabStop.focus();
                }
            }
        }
        // ESCAPE
        if (e.keyCode === 27) {
            popup.style.display = 'none';
            overlay.style.display = 'none';
            overlay.setAttribute('aria-hidden', 'true');
            focusedElementBeforeModal.focus();
        }
    }

    //close modal
    closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        popup.style.display = 'none';
        overlay.style.display = 'none';
        overlay.setAttribute('aria-hidden', 'true');
        focusedElementBeforeModal.focus();
    });
}

document.addEventListener('DOMContentLoaded', function() {
    //Find all links
    const links = document.querySelectorAll('body a');
    links.forEach(function(link) {
        link.addEventListener('click', function(event) {
            if (new URL(link.href, window.location.origin).hostname !== window.location.hostname) {
                event.preventDefault();
                let url = link.getAttribute('href');
                runInterveningPopup(url);
            }
        });
    });
    continueBtn.addEventListener('click', function() {
        window.open (
            continueBtn.getAttribute('href'), "_blank"
        );
    });
});